export const WA_NUMBER = "6281234567890";
export const WA_DISPLAY = "+62 812-3456-7890";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  general:
    "Halo Mitra Bangun Utama, saya ingin menanyakan kebutuhan sewa steger untuk proyek saya.",
  rental:
    "Halo Mitra Bangun Utama, saya ingin menyewa steger. Mohon informasi mengenai harga dan ketersediaannya.",
  buy: "Halo Mitra Bangun Utama, saya ingin membeli steger. Mohon informasi mengenai harga dan ketersediaannya.",
  quote:
    "Halo Mitra Bangun Utama, proyek kami membutuhkan steger. Mohon dibuatkan penawaran harga.",
};

export const NAV_LINKS = [
  { label: "Beranda", href: "#beranda", testid: "nav-link-beranda" },
  { label: "Why Us", href: "#why-us", testid: "nav-link-why-us" },
  { label: "Sewa & Jual", href: "#layanan", testid: "nav-link-layanan" },
  { label: "Cara Order", href: "#cara-order", testid: "nav-link-cara-order" },
  { label: "Proyek", href: "#proyek", testid: "nav-link-proyek" },
  { label: "FAQ", href: "#faq", testid: "nav-link-faq" },
];

export const IMAGES = {
  crew: "/images/hero-crane.webp",
  crane: "/images/ground-crew.webp",
  campus: "/images/night-tower.webp",
  night: "/images/campus-wide.webp",
};
